import { useState, useEffect } from 'react';

export function usePosition() {
  const [loading, setLoading] = useState(true);
  const [position, setPosition] = useState<GeolocationCoordinates>();
  const [error, setError] = useState<GeolocationPositionError>();

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (geoPosition) => {
        if (position) {
          // Only set once
          return;
        }
        setLoading(false);
        setPosition(geoPosition.coords);
      },
      (error) => {
        setLoading(false);
        setError(error);
      }
    );
  }, [position]);

  return {
    loading,
    position,
    error,
  };
}
